import { render } from "./FavoritePagesBar.vue?vue&type=template&id=12730dd0&scoped=true"
import script from "./FavoritePagesBar.vue?vue&type=script&lang=js"
export * from "./FavoritePagesBar.vue?vue&type=script&lang=js"

import "./FavoritePagesBar.vue?vue&type=style&index=0&id=12730dd0&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12730dd0"]])

export default __exports__